import { useLocation } from '@gatsbyjs/reach-router';
import { useOrganizationContext } from '@navigation/OrganizationContext';
import { ExpiredModal, ExpiringSoonModal } from '@subsets/landing-page/organization/expiration';
import { differenceInCalendarDays } from 'date-fns';
import { useEffect, useState } from 'react';

const getExpirationModalData = () => {
  const expirationModalData = JSON.parse(
    localStorage.getItem('expirationModal') || '[]',
  ) as string[];
  return expirationModalData;
};

export const OrganizationExpirationWrapper = ({ forced }: { forced?: boolean }) => {
  const { organization } = useOrganizationContext();

  if (!organization && !forced) return null;
  const { expired, expirationDate, role, organizationId, name, serviceOnly } = organization;
  if ((!expirationDate || !role || !organizationId || !name) && !forced) return null;

  // Allow users to access settings page for service only organizations in order to mangage billing
  if (
    organization?.serviceOnly &&
    /\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/settings\/.*/.test(
      window.location.pathname,
    ) &&
    !forced
  ) {
    return null;
  }

  return (
    <OrganizationExpiration
      expirationDate={expirationDate}
      role={role}
      expired={expired}
      organizationId={organizationId}
      name={name}
      serviceOnly={serviceOnly}
    />
  );
};

const OrganizationExpiration = ({
  expirationDate,
  role,
  expired,
  organizationId,
  name,
  serviceOnly,
}: {
  expirationDate: string;
  role: string;
  expired: boolean;
  organizationId: string;
  name: string;
  serviceOnly: boolean;
}) => {
  const { pathname } = useLocation();
  const [expirationModalShown, setExpirationModalShown] = useState(() => {
    const expirationModalData = getExpirationModalData();
    return Boolean(expirationModalData.find((item) => item === organizationId));
  });

  useEffect(() => {
    const expirationModalData = getExpirationModalData();
    setExpirationModalShown(Boolean(expirationModalData.find((item) => item === organizationId)));
  }, [organizationId]);

  const onModalClose = () => {
    setExpirationModalShown(true);
    const expirationModalData = getExpirationModalData();
    localStorage.setItem(
      'expirationModal',
      JSON.stringify([...expirationModalData, organizationId]),
    );
  };
  const days = differenceInCalendarDays(expirationDate, new Date());

  if (pathname.includes('profile')) {
    return null;
  }

  if (role === 'admin' && !expired && days < 8 && !expirationModalShown) {
    return (
      <ExpiringSoonModal
        days={days}
        organizationId={organizationId}
        name={name}
        onClose={onModalClose}
      />
    );
  }

  if (expired) {
    return <ExpiredModal organizationId={organizationId} name={name} serviceOnly={serviceOnly} />;
  }
  return null;
};
